import { render, staticRenderFns } from "./BadgesConfig.vue?vue&type=template&id=62df34b5&scoped=true"
import script from "./BadgesConfig.vue?vue&type=script&lang=js"
export * from "./BadgesConfig.vue?vue&type=script&lang=js"
import style0 from "./BadgesConfig.vue?vue&type=style&index=0&id=62df34b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62df34b5",
  null
  
)

export default component.exports